import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { Link } from 'site-modules/shared/components/link/link';
import { FeatureFlag } from 'site-modules/shared/components/feature-flag/feature-flag';
import { AdUnit } from 'site-modules/shared/components/ad-unit/ad-unit';
import { getStaticImageUrl } from 'client/utils/image-helpers';
import edmundsLogoBlueWhite from 'client/images/logo-blue-white.svg';

import './top-rated-promo-unit.scss';

const TOP_RATED_IMG_PATH = getStaticImageUrl('/images/top-rated/2026');
const TOP_RATED_LOGO = `${TOP_RATED_IMG_PATH}/top-rated-logo.svg`;

const TOP_RATED_URL = '/top-rated/';

const ADS_PROPS = {
  // desktop
  false: { adName: 'globalbanner', md: true, lg: true, xl: true },
  // mobile
  true: { adName: 'mglobalbanner', xs: true, sm: true },
};

export function TopRatedPromoUnit({ className = null, isMobile = false }) {
  return (
    <FeatureFlag name="top-rated-promo">
      <div
        className={classnames(
          'top-rated-banner pos-r text-decoration-none py-0_5 py-md-0 ps-1_5 pe-1 ps-md-2_5 pe-md-1 ps-lg-3_5 pe-lg-2_5 d-flex flex-column flex-md-row align-items-center justify-content-center justify-content-md-between',
          className
        )}
        data-tracking-parent="edm-top-rated-banner"
      >
        <div className="d-flex flex-column align-items-center align-items-md-start">
          <div className="d-flex">
            <img src={edmundsLogoBlueWhite} alt="" className="edmunds-logo" />
          </div>
          <div className="d-flex mt-0_5 mb-0_5 mt-lg-0_75 mb-lg-0_75">
            <img src={TOP_RATED_LOGO} alt="" className="top-rated-logo w-100" />
          </div>
          <div className="top-rated-text text-white text-nowrap fw-medium hidden-md-down">
            The Six <span className="best-vehicles fst-italic">Best Vehicles</span> of 2026
          </div>
        </div>
        <div className="img-cars pt-1_25 ms-1_5 ms-lg-3 me-1_5 w-50 hidden-md-down">
          <img src={`${TOP_RATED_IMG_PATH}/three-cars.png`} alt="" className="w-100" />
        </div>
        <Link to={TOP_RATED_URL} rel="nofollow" data-tracking-id="view_content" className="top-rated-link no-focus">
          <span className="pos-r overflow-hidden btn text-white fw-medium px-1 px-lg-1_5 py-0_25 py-md-0_75">
            <span className="pos-r">
              See the Winners <i className="icon-arrow-right3 me-0_25" aria-hidden="true" />
            </span>
          </span>
        </Link>
      </div>
      <AdUnit {...ADS_PROPS[isMobile]} oneByOne renderWhenViewable={false} />
    </FeatureFlag>
  );
}

TopRatedPromoUnit.propTypes = {
  className: PropTypes.string,
  isMobile: PropTypes.bool,
};
